import { useWatch } from "react-hook-form";
import { Col, Form, Row } from "react-bootstrap";
import AsyncSelectField from "../../reusable-form-fields/async-select";
import { fetchWebsiteFunnelOptions } from "../../../services/api-declaration";
import { useTranslation } from "react-i18next";

const AssignFunnelsSection = ({
  control,
  websiteId,
  isLoading,
  showEmptyState = true
}) => {
  const { t } = useTranslation();
  const assignedFunnels = useWatch({ control, name: "assignedFunnels" }) || [];

  const handleFunnelOptions = async (params) => {
    if (!websiteId) return [];
    const response = await fetchWebsiteFunnelOptions(websiteId, params);
    return response.data?.data || [];
  };

  return (
    <Row>
      <Col md={12}>
        <Form.Group controlId="assignedFunnels">
          <Form.Label>{t("common.select")} Funnels</Form.Label>
          <AsyncSelectField
            key={websiteId}
            isMulti
            isClearable
            control={control}
            name="assignedFunnels"
            isDisabled={isLoading}
            paramName="funnelName"
            fetchData={handleFunnelOptions}
            getOptionLabel={(option) => option?.general?.funnelName}
            placeholder={`${t("common.select")} ${t("common.funnel", {
              count: 2
            })}`}
          />
        </Form.Group>
      </Col>
      {showEmptyState && !assignedFunnels.length && !isLoading && (
        <Col md={12}>
          <div className="text-secondary mt-2">
            {t("website.noFunnelsAssigned")}
          </div>
        </Col>
      )}
    </Row>
  );
};

export default AssignFunnelsSection;
